const drawerSelectors = {
    closeButton: '.drawer__close',
    inner: '.drawer__inner',
    accordion: '.custom-accordion',
    accordionTrigger: '.custom-accordion__trigger',
    accordionPanel: '.custom-accordion__panel',
    accordionContent: '.custom-accordion__content',
}

class BaseDrawer extends HTMLElement {
    constructor(selectors) {
        super();
        this.selectors = selectors;
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector(selectors.overlay).addEventListener('click', this.close.bind(this));
        this.setButtonAccessibility();
    }

    setButtonAccessibility() {
        const triggerButton = document.querySelector(this.selectors.triggerButton);
        if (!triggerButton) return;

        triggerButton.setAttribute('aria-haspopup', 'dialog');
        triggerButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(triggerButton);
        });
        triggerButton.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(triggerButton);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        requestAnimationFrame(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = document.querySelector(this.selectors.drawer);
            const focusElement = this.querySelector(drawerSelectors.inner) || this.querySelector(drawerSelectors.closeButton);
            trapFocus(containerToTrapFocusOn, focusElement);
        }, { once: true });

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

     initAccordions() {
    this.querySelectorAll(drawerSelectors.accordion).forEach(el => {
      const trigger = el.querySelector(drawerSelectors.accordionTrigger);

      trigger.addEventListener('click', () => this.toggleAccordion(el,trigger));
    });
  }

  toggleAccordion(accordion, trigger) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const panel = accordion.querySelector(drawerSelectors.accordionPanel);
    const content = accordion.querySelector(drawerSelectors.accordionContent);
    if(!panel || !content) return;

    trigger.setAttribute('aria-expanded', !isExpanded);

      if (!isExpanded) {
      const contentHeight = content.scrollHeight;
      panel.style.height = `${contentHeight}px`;
      } else {
          panel.style.height = '0';
      }
  }
}
